// import Navbar from "./Navbar";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./features/AuthContext";
import Login from "./Login";
import Navbar from "./Navbar";
import { Toaster } from "react-hot-toast";
import GlobalLoader from "../services/GlobalLoader";
import AudioOnRouteChange from "./features/AudioOnRouteChange";
import SideBar from "./SideBar";
import QuerySideMenu from "./QuerySideMenu";
import QueryButton from "./QueryButton";
import { WhatsappProvider } from "./Whatsapp/WhatsappContext";


export default function Root() {
  const navigate = useNavigate();
  const { isAuthenticated, login, logout } = useAuth();
  const [isQueryMenuOpen, setIsQueryMenuOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    const pickerTypes = new Set(["date", "time", "datetime-local"]);

    const handleNativePickerClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!pickerTypes.has(target.type) || target.disabled || target.readOnly) {
        return;
      }

      if (typeof target.showPicker === "function") {
        try {
          target.showPicker();
        } catch {
          // Some browsers can reject showPicker even on supported inputs.
        }
      }
    };

    document.addEventListener("click", handleNativePickerClick, true);
    return () => {
      document.removeEventListener("click", handleNativePickerClick, true);
    };
  }, []);
  // if (!isAuthenticated) {
  //   navigate("/login");
  // }

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate("/login", { replace: true });
  //   }
  // }, [isAuthenticated, navigate]);

  // if (!isAuthenticated) return null;
  return (
    <WhatsappProvider>
      <Navbar />
      <GlobalLoader />
      {/* <AudioOnRouteChange/> */}




      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              background: "#4CAF50", // Green for success
              color: "#fff", // White text
              padding: "10px 20px", // Adequate padding for better text alignment
              borderRadius: "8px", // Rounded corners for a softer look
              fontWeight: "500", // Bold text for emphasis
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
              fontSize: "14px", // Slightly bigger font for readability
              transition: "all 0.3s ease-in-out", // Smooth animation for transitions
            },
          },
          error: {
            style: {
              background: "#F44336", // Red for errors
              color: "#fff", // White text for contrast
              padding: "10px 20px",
              borderRadius: "8px",
              fontWeight: "500",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              fontSize: "14px",
              transition: "all 0.3s ease-in-out",
            },
          },
        }}
      />
      <div id="detail" className="flex min-h-screen">
        {/* Sidebar */}
        <SideBar />

        <main className="flex-1 overflow-y-auto pl-4 pt-4 pr-4">
          <Outlet />
          {/* <Footer /> */}
        </main>
        
        {/* Query Components */}
        {isAuthenticated && (
          <>
            <QueryButton onClick={() => setIsQueryMenuOpen(true)} />
            <QuerySideMenu 
              isOpen={isQueryMenuOpen} 
              onClose={() => setIsQueryMenuOpen(false)} 
            />
          </>
        )}
      </div>
    </WhatsappProvider>
  );
}
